import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-50 flex justify-center bg-black/60" }
const _hoisted_2 = { class: "p-0 bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center" }
const _hoisted_3 = { class: "flex flex-col w-full text-black" }
const _hoisted_4 = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center z-50 bg-black/20"
}
const _hoisted_5 = { class: "flex flex-col w-full rounded-t-md p-3 bg-gradient-to-r from-[#424c42] to-[#647064]" }
const _hoisted_6 = { class: "font-semibold text-white text-sm md:text-2xl truncate whitespace-nowrap overflow-hidden text-ellipsis" }
const _hoisted_7 = { class: "container p-4 text-left max-h-[70vh] overflow-y-auto" }
const _hoisted_8 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5" }
const _hoisted_9 = { class: "w-full px-2 md:w-5/12" }
const _hoisted_10 = { class: "block mb-1" }
const _hoisted_11 = { class: "text-sm text-red-500 p-error" }
const _hoisted_12 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_13 = { class: "block mb-1" }
const _hoisted_14 = { class: "text-sm text-red-500 p-error" }
const _hoisted_15 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_16 = { class: "block mb-1" }
const _hoisted_17 = { class: "text-sm text-red-500 p-error" }
const _hoisted_18 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5" }
const _hoisted_19 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_20 = { class: "block mb-1" }
const _hoisted_21 = { class: "text-sm text-red-500 p-error" }
const _hoisted_22 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_23 = { class: "text-sm text-red-500 p-error" }
const _hoisted_24 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_25 = { class: "text-sm text-red-500 p-error" }
const _hoisted_26 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5" }
const _hoisted_27 = { class: "w-full px-2 md:w-9/12" }
const _hoisted_28 = { class: "text-sm text-red-500 p-error" }
const _hoisted_29 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_30 = { class: "text-sm text-red-500 p-error" }
const _hoisted_31 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_32 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_33 = { class: "text-sm text-red-500 p-error" }
const _hoisted_34 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_35 = { class: "text-sm text-red-500 p-error" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = ["empresaRedSocial"]
const _hoisted_38 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_39 = { class: "w-full px-2" }
const _hoisted_40 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5" }
const _hoisted_41 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_42 = { class: "block mb-1" }
const _hoisted_43 = { class: "text-sm text-red-500 p-error" }
const _hoisted_44 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_45 = { class: "block mb-1" }
const _hoisted_46 = { class: "text-sm text-red-500 p-error" }
const _hoisted_47 = { class: "w-full" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = ["tag"]
const _hoisted_50 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_51 = { class: "w-full px-2" }
const _hoisted_52 = { class: "block mb-1" }
const _hoisted_53 = { class: "p-3 flex flex-col md:flex-row gap-2 justify-end w-full bg-gray-100" }
const _hoisted_54 = {
  type: "submit",
  class: "cursor-pointer px-6 text-sm font-bold text-[#424c42] bg-transparent py-3 border border-[#424c42] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Select = _resolveComponent("Select")!
  const _component_InputGroupAddon = _resolveComponent("InputGroupAddon")!
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Form = _resolveComponent("Form")!
  const _component_BlockUI = _resolveComponent("BlockUI")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "m-5 w-full md:w-8/12 lg:w-6/12",
        onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.closeDialog(false)), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_BlockUI, { visible: _ctx.blocked }, {
              default: _withCtx(() => [
                (_ctx.blocked)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_ProgressSpinner, {
                        style: {"width":"50px","height":"50px"},
                        strokeWidth: "5",
                        fill: "transparent",
                        animationDuration: ".5s"
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['far', 'fa-building'],
                      class: "w-6 h-6 text-white"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('titulo.editar.datos.empresa')), 1)
                ]),
                _createVNode(_component_Form, {
                  "validation-schema": _ctx.schema,
                  onInvalidSubmit: _ctx.onInvalidSubmit,
                  onSubmit: _ctx.aplicarCambios
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('label.nombre.fantasia')), 1),
                          _createVNode(_component_Field, {
                            name: "nombreFantasia",
                            modelValue: _ctx.formData.nombreFantasia,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.nombreFantasia) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "text",
                                class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                                placeholder: _ctx.$t('label.nombre.fantasia')
                              }), null, 16, ["placeholder", "class"]),
                              _createElementVNode("span", _hoisted_11, [
                                _createVNode(_component_ErrorMessage, { name: "nombreFantasia" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('label.razon.social')), 1),
                          _createVNode(_component_Field, {
                            name: "razonSocial",
                            modelValue: _ctx.formData.razonSocial,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.razonSocial) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "text",
                                class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                                placeholder: _ctx.$t('label.razon.social')
                              }), null, 16, ["placeholder", "class"]),
                              _createElementVNode("span", _hoisted_14, [
                                _createVNode(_component_ErrorMessage, { name: "razonSocial" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('label.cuit')), 1),
                          _createVNode(_component_Field, {
                            name: "cuit",
                            modelValue: _ctx.formData.cuit,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.cuit) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "number",
                                class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                                placeholder: _ctx.$t('label.cuit')
                              }), null, 16, ["placeholder", "class"]),
                              _createElementVNode("span", _hoisted_17, [
                                _createVNode(_component_ErrorMessage, { name: "cuit" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('label.pais')), 1),
                          _createVNode(_component_Field, {
                            name: "pais",
                            modelValue: _ctx.formData.pais,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.pais) = $event))
                          }, {
                            default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                              _createVNode(_component_Select, {
                                onBlur: handleBlur,
                                filter: "",
                                "onUpdate:modelValue": handleChange,
                                "model-value": value,
                                placeholder: _ctx.$t('label.pais'),
                                class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }]),
                                options: _ctx.paises,
                                optionLabel: "descripcion"
                              }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "placeholder", "options", "class"]),
                              _createElementVNode("span", _hoisted_21, [
                                _createVNode(_component_ErrorMessage, { name: "pais" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block mb-1" }, "Provincia / Estado", -1)),
                          _createVNode(_component_Field, {
                            name: "provincia",
                            modelValue: _ctx.formData.provincia,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.provincia) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "text",
                                placeholder: "Provincia / Estado",
                                class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                              }), null, 16, ["class"]),
                              _createElementVNode("span", _hoisted_23, [
                                _createVNode(_component_ErrorMessage, { name: "provincia" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block mb-1" }, "Localidad / Ciudad", -1)),
                          _createVNode(_component_Field, {
                            name: "localidad",
                            modelValue: _ctx.formData.localidad,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.localidad) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "text",
                                placeholder: "Localidad / Ciudad",
                                class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                              }), null, 16, ["class"]),
                              _createElementVNode("span", _hoisted_25, [
                                _createVNode(_component_ErrorMessage, { name: "localidad" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _cache[16] || (_cache[16] = _createElementVNode("label", { class: "block mb-1" }, "Domicilio", -1)),
                          _createVNode(_component_Field, {
                            name: "domicilio",
                            modelValue: _ctx.formData.domicilio,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.domicilio) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "text",
                                placeholder: "Domicilio",
                                class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                              }), null, 16, ["class"]),
                              _createElementVNode("span", _hoisted_28, [
                                _createVNode(_component_ErrorMessage, { name: "domicilio" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _cache[17] || (_cache[17] = _createElementVNode("label", { class: "block mb-1" }, "C.P.", -1)),
                          _createVNode(_component_Field, {
                            name: "codigoPostal",
                            modelValue: _ctx.formData.codigoPostal,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.codigoPostal) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "text",
                                placeholder: "Código postal",
                                class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                              }), null, 16, ["class"]),
                              _createElementVNode("span", _hoisted_30, [
                                _createVNode(_component_ErrorMessage, { name: "codigoPostal" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]),
                      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "w-full border border-gray-300 py-2 text-center font-semibold text-gray-500 shadow-md rounded-xl mt-4" }, " Datos comerciales y de contacto ", -1)),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _cache[18] || (_cache[18] = _createElementVNode("label", { class: "block mb-1" }, "Mail comercial", -1)),
                          _createVNode(_component_Field, {
                            name: "mailComercial",
                            modelValue: _ctx.formData.mailComercial,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.mailComercial) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "mail",
                                placeholder: "Mail comercial",
                                class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                              }), null, 16, ["class"]),
                              _createElementVNode("span", _hoisted_33, [
                                _createVNode(_component_ErrorMessage, { name: "mailComercial" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _cache[19] || (_cache[19] = _createElementVNode("label", { class: "block mb-1" }, "Teléfono comercial", -1)),
                          _createVNode(_component_Field, {
                            name: "telefono",
                            modelValue: _ctx.formData.telefono,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.telefono) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "text",
                                placeholder: "Teléfono comercial",
                                class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                              }), null, 16, ["class"]),
                              _createElementVNode("span", _hoisted_35, [
                                _createVNode(_component_ErrorMessage, { name: "telefono" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]),
                      (_ctx.formData.empresaRedesSociales)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.empresaRedesSociales, (empresaRedSocial) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: empresaRedSocial.id,
                                empresaRedSocial: empresaRedSocial
                              }, [
                                _createElementVNode("div", _hoisted_38, [
                                  _createElementVNode("div", _hoisted_39, [
                                    _createVNode(_component_InputGroup, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_InputGroupAddon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_font_awesome_icon, {
                                              class: "text-black",
                                              icon: empresaRedSocial.redSocial.icono.split(' ')
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_Field, {
                                          name: `link-${empresaRedSocial.id}`,
                                          modelValue: empresaRedSocial.link,
                                          "onUpdate:modelValue": ($event: any) => ((empresaRedSocial.link) = $event)
                                        }, {
                                          default: _withCtx(({ field, errors }) => [
                                            _createVNode(_component_InputText, {
                                              modelValue: empresaRedSocial.link,
                                              "onUpdate:modelValue": ($event: any) => ((empresaRedSocial.link) = $event),
                                              placeholder: empresaRedSocial.redSocial.descripcion,
                                              class: _normalizeClass(["input-group-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }])
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "class"])
                                          ]),
                                          _: 2
                                        }, 1032, ["name", "modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ])
                                ])
                              ], 8, _hoisted_37))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t('label.pabellon')), 1),
                          _createVNode(_component_Field, {
                            name: "pabellon",
                            modelValue: _ctx.formData.pabellon,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.pabellon) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "text",
                                class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                                placeholder: _ctx.$t('label.pabellon')
                              }), null, 16, ["placeholder", "class"]),
                              _createElementVNode("span", _hoisted_43, [
                                _createVNode(_component_ErrorMessage, { name: "pabellon" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.$t('label.numero.stand')), 1),
                          _createVNode(_component_Field, {
                            name: "stand",
                            modelValue: _ctx.formData.stand,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.stand) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "text",
                                class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                                placeholder: _ctx.$t('label.numero.stand')
                              }), null, 16, ["placeholder", "class"]),
                              _createElementVNode("span", _hoisted_46, [
                                _createVNode(_component_ErrorMessage, { name: "stand" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]),
                      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "w-full border border-gray-300 py-2 text-center font-semibold text-gray-500 shadow-md rounded-xl mt-4" }, " Etiquetas ", -1)),
                      _createElementVNode("div", _hoisted_47, [
                        (_ctx.formData.tags)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.tags, (tag) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: tag.id,
                                  tag: tag
                                }, [
                                  _createElementVNode("div", _hoisted_50, [
                                    _createElementVNode("div", _hoisted_51, [
                                      _createElementVNode("label", _hoisted_52, _toDisplayString(tag.descripcion), 1),
                                      _createVNode(_component_Field, {
                                        name: `tag-${tag.id}`
                                      }, {
                                        default: _withCtx(({ errors }) => [
                                          _createVNode(_component_MultiSelect, {
                                            "model-value": tag.opcionesTagSeleccionados,
                                            "onUpdate:modelValue": val => tag.opcionesTagSeleccionados = val,
                                            options: tag.opciones,
                                            optionLabel: "descripcion",
                                            optionValue: "id",
                                            filter: "",
                                            placeholder: tag.descripcion,
                                            class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && tag.opcionesTagSeleccionados?.length > 0, 'input-error': errors.length > 0 }])
                                          }, null, 8, ["model-value", "onUpdate:modelValue", "options", "placeholder", "class"])
                                        ]),
                                        _: 2
                                      }, 1032, ["name"])
                                    ])
                                  ])
                                ], 8, _hoisted_49))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("a", {
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.closeDialog(false))),
                        class: "cursor-pointer px-6 text-sm font-bold text-red-500 bg-transparent py-3 border border-red-500 shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-xmark'] }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.cancelar')), 1)
                      ]),
                      _createElementVNode("button", _hoisted_54, [
                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-check-double'] }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.aplicar.cambios')), 1)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["validation-schema", "onInvalidSubmit", "onSubmit"])
              ]),
              _: 1
            }, 8, ["visible"])
          ])
        ])
      ])
    ])
  ]))
}